// extracted by mini-css-extract-plugin
module.exports = {"lang":"lU","langWrap":"lV","item":"lW","itemCurrent":"lX"};